<template>
	<q-card style="width: 80vw; min-width: 80vw; height: 80vh">
		<q-toolbar>
			<q-toolbar-title>{{ $t('support_material_preview') }}</q-toolbar-title>

			<q-btn flat round dense icon="fal fa-times" v-close-popup />
		</q-toolbar>

		<q-separator />

		<q-card-section>
			<div class="row q-col-gutter-md">
				<div class="col-4">
					<q-card class="q-py-sm full-height">
						<q-card-section>
							<div class="row q-col-gutter-md">
								<div class="col-2">
									<q-icon
										:name="$extensionIcon(material.extension).icon"
										size="lg"
										color="grey-6"
									/>
								</div>

								<div class="col-7">
									<div class="row">
										<div class="col-12 text-h5 title">
											{{ material.title }}
										</div>

										<div class="col-12 text-grey-6">
											{{ $t($activityName(material.extension)) }}
										</div>
									</div>
								</div>

								<div class="col-3">
									<q-btn round size="lg" color="primary" @click="downloadFile()">
										<q-icon name="fas fa-download" size="sm" color="white" />
									</q-btn>
								</div>
							</div>
						</q-card-section>

						<q-separator />

						<q-card-actions align="center">
							<div class="row">
								<div class="col">
									<div class="row">
										<div class="col-3">
											<q-icon size="lg" name="fal fa-download" color="grey-6" />
										</div>

										<div class="col-9 q-pl-md">
											<span class="text-body2 text-grey-6">
												{{ $t('downloads') }} </span
											><br />
											{{ material.hits }}
										</div>
									</div>
								</div>

								<div class="col q-pl-lg">
									<div class="row">
										<div class="col-3">
											<q-icon size="lg" name="fal fa-file" color="grey-6" />
										</div>

										<div class="col-9 q-pl-md">
											<span class="text-body2 text-grey-6">
												{{ $t('size') }} </span
											><br />
											{{ material.size }}
										</div>
									</div>
								</div>
							</div>
						</q-card-actions>
					</q-card>
				</div>

				<div class="col-8">
					<q-card>
						<q-card-section class="card-players">
							<pdf-visualizer :file_preview="material.file_preview" v-if="showPlayer(['pdf'])" />

							<office-visualizer
								:file_url="material.resource_url"
								v-else-if="showPlayer(['ppt', 'pptx', 'doc', 'docx', 'xls', 'xlsx'])"
							/>

							<video-visualizer
								:file_url="material.resource_url"
								:id="material.id"
								v-else-if="showPlayer(['mp4', 'mkv', 'mov', 'wmv'])"
							/>

							<audio-visualizer
								:file_url="material.resource_url"
								:id="material.id"
								v-else-if="showPlayer(['mp3', 'ogg', 'wav'])"
							/>

							<image-visualizer
								:file_url="material.resource_url"
								v-else-if="showPlayer(['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg'])"
							/>

							<div v-else class="row q-col-gutter-md">
								<div class="col-12">
									<q-icon name="fal fa-eye-slash" size="4rem" />
								</div>

								<div class="col-12 text-h5">
									{{ $t('no_pre_visualization_available') }}
								</div>
							</div>
						</q-card-section>
					</q-card>
				</div>
			</div>
		</q-card-section>
	</q-card>
</template>

<script>
import SupportMaterial from 'components/courses/desktop/SupportMaterial'
import Pdf from 'components/visualizers/Pdf'
import Office from 'components/visualizers/Office'
import Video from 'components/visualizers/Video'
import Audio from 'components/visualizers/Audio'
import Image from 'components/visualizers/Image'

export default {
	name: 'CoursesSupportMaterialPreviewDesktop',

	props: ['material'],

	components: {
		'support-material': SupportMaterial,
		'pdf-visualizer': Pdf,
		'office-visualizer': Office,
		'video-visualizer': Video,
		'audio-visualizer': Audio,
		'image-visualizer': Image,
	},

	methods: {
		downloadFile() {
			this.$emit('downloadFile', this.material)
		},

		showPlayer(type) {
			let obj = type.find((obj) => {
				return obj === this.material.extension
			})
			if (obj) return true
			else return false
		},
	},
}
</script>

<style lang="scss" scoped>
.card-players {
	height: 65vh;
	text-align: center;
}
</style>
